import moment from "moment";

export const getDates = (dateFrom: Date, dateTo: Date): Date[] => {
  let dates = [dateFrom];

  while (moment(dates[dates.length - 1]).isBefore(moment(dateTo), "day")) {
    dates.push(
      moment(dates[dates.length - 1])
        .add(1, "day")
        .toDate()
    );
  }

  return dates;
};

export const getRandomColor = (): string => {
  let letters = "0123456789ABCDEF".split("");
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};
